/**
 * Secure storage utility with obfuscation.
 * Auth data stored in localStorage with 24h TTL.
 * Values are base64-encoded to prevent casual inspection.
 * On logout, all keys are cleared immediately.
 */

const TOKEN_KEY = 'proxima_session_token';
const USER_KEY = 'proxima_user';
const TIMESTAMP_KEY = 'proxima_auth_timestamp';

const encode = (val) => {
  try { return btoa(unescape(encodeURIComponent(val))); }
  catch (e) { console.error('secureStorage encode failed:', e); return val; }
};

const decode = (val) => {
  try { return decodeURIComponent(escape(atob(val))); }
  catch (e) { console.error('secureStorage decode failed:', e); return val; }
};

export const secureStorage = {
  setToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, encode(token));
  },

  getToken() {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return null;
    // Check TTL
    const ts = localStorage.getItem(TIMESTAMP_KEY);
    if (ts) {
      const timestamp = parseInt(decode(ts));
      if (Date.now() - timestamp > 7 * 24 * 60 * 60 * 1000) {
        // Token expired (7 days)
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(TIMESTAMP_KEY);
        return null;
      }
    }
    return decode(raw);
  },

  setUser(user) {
    if (user) {
      localStorage.setItem(USER_KEY, encode(JSON.stringify(user)));
      localStorage.setItem(TIMESTAMP_KEY, encode(Date.now().toString()));
    }
  },

  getUser() {
    try {
      const stored = localStorage.getItem(USER_KEY);
      const ts = localStorage.getItem(TIMESTAMP_KEY);
      if (stored && ts) {
        const timestamp = parseInt(decode(ts));
        if (Date.now() - timestamp < 7 * 24 * 60 * 60 * 1000) {
          return JSON.parse(decode(stored));
        }
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(TIMESTAMP_KEY);
      }
    } catch (e) {
      console.error('secureStorage getUser failed:', e);
      localStorage.removeItem(USER_KEY);
      localStorage.removeItem(TIMESTAMP_KEY);
    }
    return null;
  },

  clearAll() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TIMESTAMP_KEY);
  },
};
